import { useMutation } from "@tanstack/react-query";

import { broadcastAPI } from "@api/broadcast";
import { processRequest } from "@api/config";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useStartBroadcastMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.START_BROADCAST,
				request: (token) => broadcastAPI.startBroadcastAsync({ token }),
			});
		},
	});

export const useStopBroadcastMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.STOP_BROADCAST,
				request: (token) => broadcastAPI.stopBroadcastAsync({ token }),
			});
		},
	});

export const useGetBroadcastSettingsQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.GET_BROADCAST_SETTINGS],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_BROADCAST_SETTINGS,
				request: (token) => broadcastAPI.getBroadcastSettingsAsync({ token }),
			});

			const getVrStreamId = data.stream3DKey;
			const cutUrl = getVrStreamId.split("?token=")[0];
			return { ...data, vrStreamId: cutUrl };
		},
	});
